import { useTranslation } from 'react-i18next'
import { Switch, Route } from 'react-router'
import SettingsLayout from '@/features/Settings/Layout'
import SocialLoginPasswordDashboard from './social-login-password-dashboard'

const SocialLoginPasword = () => {
  const { t } = useTranslation()

  return (
    <SettingsLayout title={t('b.settings.view.change_password.label', 'Login & Password')}>
      <Switch>
        <Route
          exact
          path="/settings/social-login-password"
          component={SocialLoginPasswordDashboard}
        />
      </Switch>
    </SettingsLayout>
  )
}

export default SocialLoginPasword
